import Service from './Service';

export default class DataResetService extends Service {
    constructor() {
        super();
        this.baseURL = 'storemanagement/datareset/';
    }


}